export const UK_CUSTOMS_PROCEDURE_HELP_SECTION_ID = "uk-customs-procedures";
